const projects = [
  {
    title: "SAHA Travel Buddy",
    tech: "Kore.ai , HTML , CSS",
    desc: "A travel assistant chatbot built on the Kore.ai platform to help travellers plan and get around on their trips.",
    link: "https://vickeysvibe.github.io/sahabot/SAHA%20bot/index.html",
  },
  {
    title: "ANA - Automated Notes Assistant",
    tech: "Python , Langchain , Streamlit",
    desc: "An educational AI assistant that answers your questions from YouTube videos, PDFs and webinars.",
    link: "https://github.com/Vickeysvibe/V-Commerce",
  },
  {
    title: "V-Commerce",
    tech: "Next.js , MongoDB , Tailwind, Node",
    desc: "A two-way e-commerce platform to buy and sell products, built with a focus on user experience.",
    link: "https://v-commerce.vercel.app",
  },

  {
    title: "Quote-o-Gram",
    tech: "MERN - stack",
    desc: "A text-based social network for sharing quotes, with likes, comments and JWT authentication.",
    link: "https://github.com/Vickeysvibe/Quote-o-gram",
  },
  {
    title: "ConstructEase",
    tech: "MERN - stack, Excel.js, puppeteer",
    desc: "A site management platform for construction companies to manage sites, contractors, vendors and products.",
    link: "https://github.com/Vickeysvibe/ConstructEaseBackend",
  },
];

export default projects;
